var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-base-checkbox"},[_c('VCheckbox',{model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }